<div class="disableScroll">
    <button class="closebtnPosition" mat-button color="accent" (click)="closeSlider()"
        [attr.id]="buildTemplateId('close-button')">
        <span class="icon-ic-close popup_close"></span>
    </button>
    <h1 class="p-l-xl p-t-m"> Folder Structure </h1>
    <div class="enableScroll tree-container">
        <app-tree [data]="data"></app-tree>
    </div>  
</div>